import React, { useEffect, useState } from "react";
import { Card, Pagination, Stack, Button } from "@mui/material";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Table from "examples/Tables/Table";
import TableData from "./data/tabledata";
import { baseURL } from "utils/api";
import Loading from "components/ApnaLoading";
import NotFound from "components/notFound";
import toast from "react-hot-toast";
import EditForm from "./editForm";
import SoftButton from "components/SoftButton";
import { Download } from "@mui/icons-material";
import TermModal from "./termModal";
import SoftInput from "components/SoftInput";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";


function Index() {

const userTheme = useSelector((state) => state.commonSlice.theme);

  const matches = useMediaQuery("(max-width:600px)");
  const [data, setData] = useState([]);
  const { columns, rows } = data;
  const id = localStorage.getItem("id");
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showTerm, setShowTerm] = useState(false);
  const [offerId, setOfferId] = useState("");
  const [searchData, setSearchData] = useState('');
  const [mainType, setMainType] = useState('');
  const [refresh, setRefresh] = useState(0)


  const fetchData = (ev, searchData) => {
    setLoading(true);
    fetch(`${baseURL}/get-all-templates-for-business/${id}?page=${ev}&searchdata=${searchData}`)
      .then((res) => res.json())
      .then((data) => {
          setTotalPage(data?.totalPages);
          setData(
            TableData({
              data: data?.offerData,
              handleActivateOffer: ShowTerms,
              handleEditOffer: handleEditOffer,
            })
          );
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err.message || 'Something went wrong');;
      });
  };

  const handleEditOffer = (templateId,type) => {
    setShow(true);
    setOfferId(templateId);
    setMainType(type)
  };

  const ShowTerms = (templateId) => {
    setShowTerm(true);
    setOfferId(templateId);
  };

  const handleActivateOffer = (templateId) => {
    fetch(`${baseURL}/activate-offer-template`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        businessUserId: id,
        templateId: templateId,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 200) {
          setShowTerm(false);
          fetchData(page, searchData);
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => {
        toast.error(err.message || 'Something went wrong');;
      });
  };

  const handlePageChange = (page) => {
    setPage(page);
    fetchData(page, searchData);
    
  };


  const exportFile = (ev, searchData, main) => {
    setLoading(true);
    fetch(`${baseURL}/get-all-templates-for-business/${id}/${main}?page=${ev}&searchData=${searchData}`)
        .then(res => res.json())
        .then(data => {
            if (data.status === 200) {
              if (main === 'pdf') {
                const blob = new Blob([new Uint8Array(data?.download?.data)], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', 'file.pdf');
                document.body.appendChild(link);
                link.click();
                link.remove();
              } else {
                const blob = new Blob([new Uint8Array(data?.download?.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', 'file.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
              }
            }
            setLoading(false);
        })
        .catch(err => {
            toast.error(err.message || 'Something went wrong');;
            setLoading(false);
        });
};


  const onSearchChange = (e) => {
    fetchData(page, e.target.value);
    setSearchData(e.target.value);
  };

  useEffect(() => {
    fetchData(page, searchData);
  }, [refresh]);

   const handelRefresh = () => {  
    setRefresh(refresh + 1) 
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <EditForm handelRefresh={handelRefresh}  setShowTerm={setShowTerm} type={mainType} show={show} unShow={setShow} offerId={offerId} />
      <TermModal  show={showTerm} unShow={setShowTerm} offerId={offerId} handleActivateOffer={handleActivateOffer} />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card className="glassmorphism-card">
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
               <SoftBox
                    sx={{
                      display: 'flex',
                      flexDirection: matches?'column':'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      m: 2
                    }}
                  >

                    <SoftBox sx={{ mt: matches?1:4 }}
                      width={matches?'100%':'50%'}
                    >
                      <SoftInput
                        onChange={onSearchChange}
                        placeholder="Search here..."
                        icon={{ component: "search", direction: "left" }}
                      />
                    </SoftBox>
                    <SoftBox mt={2} display="flex" gap={2} alignItems='center' justifyContent='center' >
                      <SoftButton variant="contained" style={{ backgroundColor: userTheme === 'dark' ? '#1e1e1e' : 'gainsboro', color: userTheme === 'dark' ? '#ffffff' : '#000000' }}
                        disabled={rows?.length === 0}
                        onClick={() => exportFile(page, searchData, 'excel')}
                      >

                        <img
                          src={require("../../assets/images/xls.png")}
                          alt="excel"
                          style={{ width: "30px", height: "30px", marginRight: "10px" }}
                        />
                        
                        <SoftBox ml={1} mt={1}
                              sx={{color: userTheme === 'dark' ? '#ffffff' : '#000000'}}
                        >
                          <Download />
                        </SoftBox>
                      </SoftButton>
                      <SoftButton variant="contained"  style={{ backgroundColor: userTheme === 'dark' ? '#1e1e1e' : 'gainsboro', color: userTheme === 'dark' ? '#ffffff' : '#000000' }}
                        disabled={rows?.length === 0}
                        onClick={() => exportFile(page, searchData, 'pdf')}
                      >
                        <img
                          src={require("../../assets/images/pdff.png")}
                          alt="excel"
                          style={{ width: "30px", height: "30px", marginRight: "10px" }}
                        />
                        
                        <SoftBox ml={1} mt={1}
                              sx={{color: userTheme === 'dark' ? '#ffffff' : '#000000'}}
                        >
                          <Download />
                        </SoftBox>
                      </SoftButton>
                    </SoftBox>
                  </SoftBox>
              {loading ? (
                <Loading />
              ) : rows?.length > 0 ? (
                <>
                 
                  <Table columns={columns} rows={rows} />

                </>
              ) : (
                <NotFound />
              )}
            </SoftBox>
            {
              rows && rows?.length > 0 &&
              <>
                <Stack spacing={5} m={5} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Pagination
                    onChange={(event, page) => handlePageChange(page)}
                    count={totalPage}
                    variant="outlined"
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: "gray", // Inactive color
                        borderColor: "gray",
                      },
                      "& .Mui-selected": {
                        color: "#ffffff", // Active color
                        borderColor: "#ffffff",
                      },
                    }}
                    shape="rounded"
                  />
                </Stack>
              </>
            }
          </Card>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
}

export default Index;
